<template>
  <div class="w-full" style="display: flex; justify-content: center; align-items: center; min-height: 50vh;">
    <div class="text-center max-w-lg px-4">
      <h1 class="not-found-code">404</h1>
      <h2 class="not-found-title">Page Not Found</h2>
      <p class="not-found-message">
        Sorry, the page you're looking for doesn't exist or has been moved.
      </p>
      <p class="not-found-hint">
        You may have entered the URL incorrectly or the page may have been removed.
      </p>
      <router-link to="/" class="btn btn-blue">
        Return to Home
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>

<style scoped>
.not-found-code {
  font-size: 6rem;
  font-weight: bold;
  color: #003a78;
  margin: 0;
  line-height: 1;
}

.not-found-title {
  font-size: 1.5rem;
  color: #333;
  margin: 1rem 0;
}

.not-found-message {
  color: #666;
  margin-bottom: 0.5rem;
}

.not-found-hint {
  color: #888;
  font-size: 0.9rem;
  margin-bottom: 2rem;
}
</style>